module.exports = __webpack_public_path__ + "static/niche-manufacturing-56c1e8436882ac3c9f32529fa151de96.svg";